const state = {
  isLoading: false,
  data: {},
  orders: [],
  brandCategory: {},
};

export default state;
